import React, { useState, useEffect } from "react";
import { Toolbar, Typography } from "@material-ui/core";
import { Container, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import routes from "./api/routes";
import { Route, Switch, useHistory } from "react-router-dom";
import ForecastAndCltv from "./components/ForecastAndCltv";
import Pricing from "./components/Pricing";
import Recommendation from "./components/Recommendation"
import { checkPermission } from "../common/Sidebar/checkPermission";
const Analytics = () => {
    const [currentTab, setCurrentTab] = useState("");
    const history = useHistory();
    const defaultAccess = {
        canView : false,
        canEdit: false,
        canCreate: false,
        canDelete: false
    }
    const [permissions, setPermissions] = useState({
        salesForecastPermission: defaultAccess,
        orderForecastPermission: defaultAccess,
        pricingPermission: defaultAccess,
        customerSegPermission: defaultAccess,
        frequentItemsPermission: defaultAccess,
    });
    useEffect(() => {
        const fetchPermission = async()=>{
            const salesForecastPermission = (await checkPermission("store","analytics.salesForecast")) || defaultAccess;
            const orderForecastPermission = (await checkPermission("store","analytics.orderForecast")) || defaultAccess;
            const pricingPermission = (await checkPermission("store","analytics.pricing")) || defaultAccess;
            const customerSegPermission = (await checkPermission("store","analytics.customerSegmentation")) || defaultAccess;
            const frequentItemsPermission = (await checkPermission("store","analytics.frequentlyBoughtItems")) || defaultAccess;
            setPermissions({
                salesForecastPermission: typeof salesForecastPermission === 'object' ? salesForecastPermission : defaultAccess,
                orderForecastPermission: typeof orderForecastPermission === 'object' ? orderForecastPermission : defaultAccess,
                pricingPermission: typeof pricingPermission === 'object' ? pricingPermission : defaultAccess,
                customerSegPermission: typeof customerSegPermission === 'object' ? customerSegPermission : defaultAccess,
                frequentItemsPermission: typeof frequentItemsPermission === 'object' ? frequentItemsPermission : defaultAccess,
            });
        }
        fetchPermission()
    }, []);
    useEffect(() => {
        updateCurrentTabBasedOnPermissions();
    }, [permissions]);
    const updateCurrentTabBasedOnPermissions = () => {
        const tabPermissions = {
            salesForecastPermission: "SalesForecast",
            orderForecastPermission: "OrderForeCast",
            pricingPermission: "Pricing",
            customerSegPermission: "Customer Segmentation",
            frequentItemsPermission: "Recommendation",
        };

        let currTab = "";
        for (const [permission, tab] of Object.entries(tabPermissions)) {
            if (permissions[permission]?.canView) {
                currTab = tab;
                break;
            }
        }
        setCurrentTab(currTab);
    };
    const tabChange = (key) => {
        setCurrentTab(key);
        history.push(routes.analytics.path);
    };

    return (
        <>
            <Toolbar>
                <Typography variant="h6" color="inherit">
                    Analytics
                </Typography>
            </Toolbar>
                <Col style={{ padding: 0, minWidth: '100px', position: 'relative' }}>
                    <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'flex-end',}}>
                        <Tabs activeKey={currentTab} onSelect={tabChange} transition={false} style={{ flex: 1, paddingRight: '48px' }}>
                            {permissions?.salesForecastPermission?.canView && <Tab eventKey="SalesForecast" title={<span style={{ fontSize: "15px" }}>Sales Forecast</span>}/>}
                            {permissions?.orderForecastPermission?.canView && <Tab eventKey="OrderForeCast" title={<span style={{ fontSize: "15px" }}>Order Forecast</span>}/>}
                            {permissions?.pricingPermission?.canView && <Tab eventKey="Pricing" title={<span style={{ fontSize: "15px" }}> Pricing</span>} />}
                            {permissions?.customerSegPermission?.canView && <Tab eventKey="Customer Segmentation" title={<span style={{ fontSize: "15px" }}>Customer Segmentation</span>} />}
                            {permissions?.frequentItemsPermission?.canView && <Tab eventKey="Recommendation" title={<span style={{ fontSize: "15px" }}>Frequently Bought Items</span>}/>}
                        </Tabs>
                    </div>
                </Col>
            <section id="menu" className="mt-3">
                <Container fluid>
                    <Switch>
                        <Route exact path="/analytics">
                            {currentTab === "SalesForecast" && (
                                <ForecastAndCltv type={1} chartType="Sales Forecast" permissions={permissions?.salesForecastPermission}/>
                            )}
                            {currentTab === "OrderForeCast" && (
                                <ForecastAndCltv type={2} chartType="Order Forecast" permissions={permissions?.orderForecastPermission}/>
                            )}
                            {currentTab === "Pricing" && (
                                <Pricing permissions={permissions?.pricingPermission}/>
                            )}
                            {currentTab === "Customer Segmentation" && (
                                <ForecastAndCltv type={3} chartType="CLTV Model" permissions={permissions?.customerSegPermission}/>
                            )}
                            {currentTab === "Recommendation" && <Recommendation permissions={permissions?.frequentItemsPermission}/>}
                        </Route>
                    </Switch>
                </Container>
            </section>
        </>
    );
};
export default Analytics;